module.exports = __webpack_public_path__ + "img/case_1.163e8c9a.png";